import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'nuka-carousel';
import FittedImage from 'react-fitted-img';
import { removeStartingSlash } from '../../../services/utils';

export interface IBrandLogoProps {
  logo: string;
  name: string;
  url: string;
}

export const OurCompanies = (props) => (
  <div className="our-companies">
    <div className="container">
      <Carousel {...props}>
        {...props.children}
      </Carousel>
    </div>
  </div>
);

export const BrandLogo = ({ logo, name, url }: IBrandLogoProps) => {
  return (
    <Link
      to={{
        pathname: removeStartingSlash(url)
      }}
      target="_blank"
      rel="noopener noreferrer">
      <div
        className="brand-logo"
        key={name}>
        <FittedImage
          className={'brand-logo-img'}
          fit={'contain'}
          src={logo}
          alt={name}
        />
      </div>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Home/components/OurCompanies.tsx